import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhanghaoguanli",
  "use": "icon-zhanghaoguanli-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-zhanghaoguanli\"><path d=\"M12.873 14.345l-.038.029a8.02 8.02 0 01-.273.199A7.962 7.962 0 018 16a7.965 7.965 0 01-4.813-1.609l.25.18a7.78 7.78 0 01-.817-.65 8 8 0 1110.765-.005l.215-.203a8.027 8.027 0 01-.5.451l-.045.037c-.06.049-.12.097-.182.144zM8 10.285a4.573 4.573 0 00-4.31 3.046A6.818 6.818 0 008 14.857c1.633 0 3.132-.57 4.31-1.523A4.571 4.571 0 008 10.286zm0-9.142a6.857 6.857 0 00-5.195 11.333A5.729 5.729 0 015.88 9.55a3.429 3.429 0 114.242.001 5.728 5.728 0 013.075 2.925A6.857 6.857 0 008 1.143zM8 4.57a2.286 2.286 0 100 4.572A2.286 2.286 0 008 4.57z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/zhanghaoguanli.svg
// module id = 534
// module chunks = 4